import React, {Fragment} from "react";
import {Button, Col, Form, InputNumber, Modal, Radio, Row} from "antd";
import {compose} from "redux";
import {translate} from "react-i18next";
import EnhancedModal from "../enhanced-modal";
import {
  GUTTER_MD,
  MARGIN_MD,
  MODAL_WIDTH_MD,
  SPAN_FULL,
  SPAN_ONE_QUARTER,
  SPAN_THREE_QUARTERS,
  TABLE_COL_MIN_WIDTH_ID
} from "../../styles/constants";
import {
  getLayoutAnnotationDefaultItems,
  setLayoutAnnotationDefaultItems,
  LAYOUT_ANNOTATION_DEFAULT_KEY,
  TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS,
  TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE,
} from "../../utils/annotations";
import _ from "lodash";
import InfiniteScrollTable from "../infinite-scroll-table";
import {BUTTON_DELETE, BUTTON_DETAIL} from "../../styles/buttons";
import {
  DSD_DIMENSION_ID_TIME,
  DSD_DIMENSION_TYPE_TIME,
  getArtefactTripletFromString,
  getArtefactTripletFromUrn,
  getStringFromArtefactTriplet
} from "../../utils/sdmxJson";
import {DataLanguageConsumer} from "../../contexts/DataLanguage";
import {connect} from "react-redux";
import ItemList from "../item-list";
import Selector from "../selector";
import InfiniteScrollDataTable from "../infinite-scroll-data-table";
import Call from "../../hocs/call";
import LocalizedMonthPicker from "../localized-month-picker";
import moment from "moment";

const mapStateToProps = state => ({
  appLanguage: state.app.language
});

const timeDimensionEditFormItemLayout = {
  labelCol: {span: SPAN_ONE_QUARTER},
  wrapperCol: {span: SPAN_THREE_QUARTERS}
};



class Default extends React.Component {

  constructor(props) {
    super(props);

    const defaultLayoutAnnotation = this.props.annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];
    const defaultObj = getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig);

    this.state = {
      isEditTableVisible: false,
      tempEditTableChecked: null,
      codesEditTableId: null,
      tempCodesEditTableChecked: null,
      codelistTriplet: null,
      isTimeDimensionEditTableVisible: false,
      tempTimeDimensionStart: null,
      tempTimeDimensionEnd: null,
      tempTimeDimensionLastNObservations: null,
      tempTimeDimensionLastNPeriods: null,
      timeDimensionMode: defaultObj[defaultLayoutAnnotation.lastNPeriod]
        ? TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS
        : TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE,
      isTimeDimensionFromListVisible: false,
      isTimeDimensionToListVisible: false,
      timeDimensionId: null
    };

    this.onEditTableShow = this.onEditTableShow.bind(this);
    this.onEditTableHide = this.onEditTableHide.bind(this);
    this.onEditTableChange = this.onEditTableChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCodesEditTableShow = this.onCodesEditTableShow.bind(this);
    this.onCodesEditTableHide = this.onCodesEditTableHide.bind(this);
    this.onCodesEditTableChange = this.onCodesEditTableChange.bind(this);
    this.onTimeDimensionEditFormShow = this.onTimeDimensionEditFormShow.bind(this);
    this.onTimeDimensionEditFormHide = this.onTimeDimensionEditFormHide.bind(this);
    this.onTempTimeDimensionStartChange = this.onTempTimeDimensionStartChange.bind(this);
    this.onTempTimeDimensionEndChange = this.onTempTimeDimensionEndChange.bind(this);
    this.onTempTimeDimensionLastNObservationsChange = this.onTempTimeDimensionLastNObservationsChange.bind(this);
    this.onTempTimeDimensionLastNPeriodsChange = this.onTempTimeDimensionLastNPeriodsChange.bind(this);
    this.onTimeDimensionModeChange = this.onTimeDimensionModeChange.bind(this);
    this.onTimeDimensionToListShow = this.onTimeDimensionToListShow.bind(this);
    this.onTimeDimensionToListHide = this.onTimeDimensionToListHide.bind(this);
    this.onTimeDimensionFromListShow = this.onTimeDimensionFromListShow.bind(this);
    this.onTimeDimensionFromListHide = this.onTimeDimensionFromListHide.bind(this);
  }

  onEditTableShow() {

    const defaultObj = getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig);
    const defaultLayoutAnnotation = this.props.annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];

    const newTempEditTableChecked = Object.keys(defaultObj);
    if (
      defaultObj[DSD_DIMENSION_ID_TIME] ||
      defaultObj[defaultLayoutAnnotation.timePeriodStart] ||
      defaultObj[defaultLayoutAnnotation.timePeriodEnd] ||
      defaultObj[defaultLayoutAnnotation.lastNObservation] ||
      defaultObj[defaultLayoutAnnotation.lastNPeriod]
    ) {
      newTempEditTableChecked.push(DSD_DIMENSION_ID_TIME);
    }

    this.setState({
      isEditTableVisible: true,
      tempEditTableChecked: newTempEditTableChecked
    });
  }

  onEditTableHide() {
    this.setState({
      isEditTableVisible: false,
      tempEditTableChecked: null
    });
  }

  onTimeDimensionEditFormShow(id) {

    const defaultLayoutAnnotation = this.props.annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];

    const {timeDimensionMode} = this.state;

    this.setState({
      isTimeDimensionEditTableVisible: true,
      tempTimeDimensionStart:
        timeDimensionMode === TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE
          ? (getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig)[defaultLayoutAnnotation.timePeriodStart] || null)
          : null,
      tempTimeDimensionEnd:
        timeDimensionMode === TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE
          ? (getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig)[defaultLayoutAnnotation.timePeriodEnd] || null)
          : null,
      tempTimeDimensionLastNObservations:
        timeDimensionMode === TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE
          ? (getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig)[defaultLayoutAnnotation.lastNObservation] || null)
          : null,
      tempTimeDimensionLastNPeriods:
        timeDimensionMode === TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS
          ? (getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig)[defaultLayoutAnnotation.lastNPeriod] || null)
          : null,
      timeDimensionId: id
    });
  }

  onTimeDimensionEditFormHide() {
    this.setState({
      isTimeDimensionEditTableVisible: false,
      tempTimeDimensionStart: null,
      tempTimeDimensionEnd: null,
      tempTimeDimensionLastNObservations: null,
      tempTimeDimensionLastNPeriods: null,
      timeDimensionId: null
    });
  }

  onTempTimeDimensionStartChange(val) {
    this.setState({
      tempTimeDimensionStart: val
    });
  }

  onTempTimeDimensionEndChange(val) {
    this.setState({
      tempTimeDimensionEnd: val
    });
  }

  onTempTimeDimensionLastNObservationsChange(val) {
    this.setState({
      tempTimeDimensionLastNObservations: val
    });
  }

  onTempTimeDimensionLastNPeriodsChange(val) {
    this.setState({
      tempTimeDimensionLastNPeriods: val
    });
  }

  onTimeDimensionModeChange(val) {
    this.setState({
      timeDimensionMode: val,
      tempTimeDimensionStart: null,
      tempTimeDimensionEnd: null,
      tempTimeDimensionLastNObservations: null,
      tempTimeDimensionLastNPeriods: null
    });
  }

  onTimeDimensionFromListShow() {
    this.setState({
      isTimeDimensionFromListVisible: true
    });
  }

  onTimeDimensionFromListHide() {
    this.setState({
      isTimeDimensionFromListVisible: false
    });
    this.props.resetValuesForLayoutAnnotations();
  }

  onTimeDimensionToListShow() {
    this.setState({
      isTimeDimensionToListVisible: true
    });
  }

  onTimeDimensionToListHide() {
    this.setState({
      isTimeDimensionToListVisible: false
    });
    this.props.resetValuesForLayoutAnnotations();
  }

  onSubmit() {

    const {
      codesEditTableId
    } = this.state;

    const defaultLayoutAnnotation = this.props.annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];

    const defaultObj = {};

    const oldDefaultObj = getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig);

    (this.state.tempEditTableChecked || Object.keys(oldDefaultObj)).forEach(id =>
      defaultObj[id] =
        id === codesEditTableId
          ? this.state.tempCodesEditTableChecked || oldDefaultObj[id] || []
          : oldDefaultObj[id] || []
    );

    const hadTimeDimension =
      oldDefaultObj[DSD_DIMENSION_ID_TIME] ||
      oldDefaultObj[defaultLayoutAnnotation.timePeriodStart] ||
      oldDefaultObj[defaultLayoutAnnotation.timePeriodEnd] ||
      oldDefaultObj[defaultLayoutAnnotation.lastNObservation] ||
      oldDefaultObj[defaultLayoutAnnotation.lastNPeriod];

    if (this.state.tempTimeDimensionStart) {
      defaultObj[defaultLayoutAnnotation.timePeriodStart] = [this.state.tempTimeDimensionStart];
      delete defaultObj[DSD_DIMENSION_ID_TIME];
    } else {
      delete defaultObj[defaultLayoutAnnotation.timePeriodStart];
    }
    if (this.state.tempTimeDimensionEnd) {
      defaultObj[defaultLayoutAnnotation.timePeriodEnd] = [this.state.tempTimeDimensionEnd];
      delete defaultObj[DSD_DIMENSION_ID_TIME];
    } else {
      delete defaultObj[defaultLayoutAnnotation.timePeriodEnd];
    }
    if (this.state.tempTimeDimensionLastNObservations) {
      defaultObj[defaultLayoutAnnotation.lastNObservation] = [this.state.tempTimeDimensionLastNObservations];
      delete defaultObj[DSD_DIMENSION_ID_TIME];
    } else {
      delete defaultObj[defaultLayoutAnnotation.lastNObservation];
    }
    if (this.state.tempTimeDimensionLastNPeriods) {
      defaultObj[defaultLayoutAnnotation.lastNPeriod] = [this.state.tempTimeDimensionLastNPeriods];
      delete defaultObj[DSD_DIMENSION_ID_TIME];
    } else {
      delete defaultObj[defaultLayoutAnnotation.lastNPeriod];
    }

    if (hadTimeDimension && !(
      this.state.tempTimeDimensionStart ||
      this.state.tempTimeDimensionEnd ||
      this.state.tempTimeDimensionLastNObservations ||
      this.state.tempTimeDimensionLastNPeriods
    )) {
      defaultObj[DSD_DIMENSION_ID_TIME] = [];
    }

    this.props.onChange({
      layoutAnnotations: setLayoutAnnotationDefaultItems(_.cloneDeep(this.props.layoutAnnotations), this.props.annotationsConfig, defaultObj)
    });
    this.onEditTableHide();
    this.onCodesEditTableHide();
    this.onTimeDimensionEditFormHide();
  }

  onEditTableChange(checkedArr) {
    this.setState({
      tempEditTableChecked: checkedArr
    });
  }

  onCodesEditTableShow(id, codelistTriplet) {

    this.setState({
      codesEditTableId: id,
      codelistTriplet,
      tempCodesEditTableChecked: getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig)[id] || []
    });
  }

  onCodesEditTableHide() {
    this.setState({
      codesEditTableId: null,
      codelistTriplet: null,
      tempCodesEditTableChecked: null
    });
    this.props.resetItemsPage();
  }

  onCodesEditTableChange(checkedArr) {

    this.setState({
      tempCodesEditTableChecked: checkedArr
    });
  }

  onDeleteComponent(id) {

    const defaultLayoutAnnotation = this.props.annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];
    const defaultObj = {};

    const oldDefaultObj = getLayoutAnnotationDefaultItems(this.props.layoutAnnotations, this.props.annotationsConfig);

    Object.keys(oldDefaultObj).forEach(el => {
      if (id !== el) {
        defaultObj[el] = oldDefaultObj[el];
      }
    });

    if (id === DSD_DIMENSION_ID_TIME) {
      delete defaultObj[DSD_DIMENSION_ID_TIME];
      delete defaultObj[defaultLayoutAnnotation.timePeriodStart];
      delete defaultObj[defaultLayoutAnnotation.timePeriodEnd];
      delete defaultObj[defaultLayoutAnnotation.lastNObservation];
      delete defaultObj[defaultLayoutAnnotation.lastNPeriod];
    }

    this.props.onChange({
      layoutAnnotations: setLayoutAnnotationDefaultItems(_.cloneDeep(this.props.layoutAnnotations), this.props.annotationsConfig, defaultObj)
    });
    this.onEditTableHide();
    this.onCodesEditTableHide();
  }

  render() {
    const {
      t,
      disabled,
      noCodes,
      dsdDimensions,
      layoutAnnotations,
      annotationsConfig,
      appLanguage,
      itemCount,
      itemsPage,
      fetchItemsPage,
      valuesForLayoutAnnotations,
      fetchValuesForLayoutAnnotations
    } = this.props;

    const {
      isEditTableVisible,
      tempEditTableChecked,
      tempCodesEditTableChecked,
      codesEditTableId,
      codelistTriplet,
      isTimeDimensionEditTableVisible,
      tempTimeDimensionStart,
      tempTimeDimensionEnd,
      tempTimeDimensionLastNObservations,
      tempTimeDimensionLastNPeriods,
      timeDimensionMode,
      isTimeDimensionFromListVisible,
      isTimeDimensionToListVisible,
      timeDimensionId
    } = this.state;

    const defaultLayoutAnnotation = this.props.annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_KEY];
    const defaultObj = getLayoutAnnotationDefaultItems(layoutAnnotations, annotationsConfig);

    const dsdComponents =
      (dsdDimensions || [])
        .map(({id, localRepresentation, type}) => ({
          id,
          type,
          codelistTriplet: (
            localRepresentation && localRepresentation.enumeration &&
            getStringFromArtefactTriplet(getArtefactTripletFromUrn(localRepresentation.enumeration))
          ) || null,
          preview: type === DSD_DIMENSION_TYPE_TIME
            ? ([
              (
                defaultObj[defaultLayoutAnnotation.timePeriodStart]
                  ? defaultLayoutAnnotation.timePeriodStart + "=" + defaultObj[defaultLayoutAnnotation.timePeriodStart][0]
                  : null
              ),
              (
                defaultObj[defaultLayoutAnnotation.timePeriodEnd]
                  ? defaultLayoutAnnotation.timePeriodEnd + "=" + defaultObj[defaultLayoutAnnotation.timePeriodEnd][0]
                  : null
              ),
              (
                defaultObj[defaultLayoutAnnotation.lastNObservation]
                  ? defaultLayoutAnnotation.lastNObservation + "=" + defaultObj[defaultLayoutAnnotation.lastNObservation][0]
                  : null
              ),
              (
                defaultObj[defaultLayoutAnnotation.lastNPeriod]
                  ? defaultLayoutAnnotation.lastNPeriod + "=" + defaultObj[defaultLayoutAnnotation.lastNPeriod][0]
                  : null
              )
            ].filter(val => !!val).join(","))
            : (defaultObj[id] || []).join("+")
        }))
        .sort((a, b) =>
          a.order && b.order && a.order !== b.order
            ? a.order - b.order
            : a.id - b.id
        );

    const columns = [
      {
        title: t('data.dsd.component.id.shortLabel'),
        dataIndex: 'id',
        minWidth: TABLE_COL_MIN_WIDTH_ID
      },
      {
        title: t('components.default.dsdComponentsTable.columns.preview.title'),
        dataIndex: 'preview'
      }
    ];

    const _this = this;

    return (
      <Fragment>
        <InfiniteScrollTable
          data={
            dsdComponents
              .filter(({id, type}) =>
                (
                  type === DSD_DIMENSION_TYPE_TIME && (
                    defaultObj[DSD_DIMENSION_ID_TIME] ||
                    defaultObj[defaultLayoutAnnotation.timePeriodStart] ||
                    defaultObj[defaultLayoutAnnotation.timePeriodEnd] ||
                    defaultObj[defaultLayoutAnnotation.lastNObservation] ||
                    defaultObj[defaultLayoutAnnotation.lastNPeriod]
                  )
                ) || Object.keys(defaultObj).includes(id))
          }
          getRowKey={({id}) => id}
          columns={columns}
          actions={[
            ({id, codelistTriplet, type}) => (!noCodes)
              ? ({
                ...BUTTON_DETAIL,
                title: (type === DSD_DIMENSION_TYPE_TIME || codelistTriplet !== null)
                  ? t('components.default.dsdComponentsTable.actions.detail.title')
                  : t('components.default.dsdComponentsTable.actions.detailNoCodelist.title'),
                onClick: () => {
                  if (type === DSD_DIMENSION_TYPE_TIME) {
                    this.onTimeDimensionEditFormShow(id);
                  } else {
                    this.onCodesEditTableShow(id, codelistTriplet);
                  }
                },
                disabled: type !== DSD_DIMENSION_TYPE_TIME && codelistTriplet === null
              })
              : null,
            ({id}) => ({
              ...BUTTON_DELETE,
              title: t('components.default.dsdComponentsTable.actions.delete.title'),
              onClick: () => {
                Modal.confirm({
                  title: t('components.default.dsdComponentsTable.confirms.delete.title', {id}),
                  content: defaultObj[id] && defaultObj[id].length
                    ? t('components.default.dsdComponentsTable.confirms.delete.content')
                    : undefined,
                  onOk() {
                    _this.onDeleteComponent(id);
                  },
                  cancelText: t('commons.buttons.cancel.title')
                })
              }
            })
          ]}
          rightActions={
            !disabled && (
              <Row type="flex" justify="end">
                <Col>
                  <Button type="primary" onClick={this.onEditTableShow}>
                    {t("components.annotationsForm.layoutAnnotationDefault.editButton.title")}
                  </Button>
                  <EnhancedModal
                    visible={isEditTableVisible}
                    width={MODAL_WIDTH_MD}
                    title={t("components.annotationsForm.layoutAnnotationDefault.editTable.title")}
                    onCancel={this.onEditTableHide}
                    footer={
                      <div>
                        <Button onClick={this.onEditTableHide}>
                          {t('commons.buttons.close.title')}
                        </Button>
                        <Button
                          onClick={this.onSubmit}
                          type="primary"
                        >
                          {t('commons.buttons.save.title')}
                        </Button>
                      </div>
                    }
                  >
                    <InfiniteScrollTable
                      data={dsdComponents}
                      getRowKey={({id}) => id}
                      columns={columns}
                      rowSelection={{
                        selectedRowKeys: tempEditTableChecked || [],
                        onChange: this.onEditTableChange
                      }}
                    />
                  </EnhancedModal>
                </Col>
              </Row>
            )
          }
        />
        <EnhancedModal
          visible={codesEditTableId !== null}
          width={MODAL_WIDTH_MD}
          title={t("components.annotationsForm.layoutAnnotationDefault.codesEditTable.title", {componentId: codesEditTableId})}
          onCancel={this.onCodesEditTableHide}
          footer={
            <div>
              <Button onClick={this.onCodesEditTableHide}>
                {t('commons.buttons.close.title')}
              </Button>
              <Button
                onClick={this.onSubmit}
                type="primary"
              >
                {t('commons.buttons.save.title')}
              </Button>
            </div>
          }
          withDataLanguageSelector
        >
          <DataLanguageConsumer>
            {dataLanguage => {
              const language = dataLanguage || appLanguage;
              return (
                <ItemList
                  data={itemsPage || null}
                  rowCount={itemCount}
                  isPaginated
                  onChange={
                    ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                      fetchItemsPage(
                        {
                          codelistTriplet: getArtefactTripletFromString(codelistTriplet),
                          language,
                          pageNum,
                          pageSize,
                          searchText,
                          filters,
                          sortCol,
                          sortByDesc
                        },
                        codesEditTableId,
                        tempCodesEditTableChecked || []
                      )
                  }
                  rowSelection={{
                    selectedRowKeys: (tempCodesEditTableChecked || []),
                    onChange: this.onCodesEditTableChange
                  }}
                />
              );
            }}
          </DataLanguageConsumer>
        </EnhancedModal>
        <EnhancedModal
          visible={isTimeDimensionEditTableVisible}
          width={MODAL_WIDTH_MD}
          title={t("components.annotationsForm.layoutAnnotationDefault.timeDimensionEdit.title")}
          onCancel={this.onTimeDimensionEditFormHide}
          footer={
            <div>
              <Button onClick={this.onTimeDimensionEditFormHide}>
                {t('commons.buttons.close.title')}
              </Button>
              <Button
                onClick={this.onSubmit}
                type="primary"
              >
                {t('commons.buttons.save.title')}
              </Button>
            </div>
          }
        >
          <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
            <Col span={SPAN_FULL}>
              <Form.Item
                label={t('data.dsd.timDimension.mode.label')}
                {...timeDimensionEditFormItemLayout}
              >
                <Radio.Group
                  disabled={disabled}
                  value={timeDimensionMode}
                  onChange={({target}) => {
                    if (
                      tempTimeDimensionStart ||
                      tempTimeDimensionEnd ||
                      tempTimeDimensionLastNObservations ||
                      tempTimeDimensionLastNPeriods
                    ) {
                      const _this = this;
                      Modal.confirm({
                        title: t('components.annotationsForm.layoutAnnotationDefault.timeDimensionEdit.modeChangeConfirm.title'),
                        content: t('components.annotationsForm.layoutAnnotationDefault.timeDimensionEdit.modeChangeConfirm.content'),
                        onOk() {
                          _this.onTimeDimensionModeChange(target.value)
                        },
                        cancelText: t('commons.buttons.cancel.title')
                      })
                    } else {
                      this.onTimeDimensionModeChange(target.value)
                    }
                  }}
                >
                  <Radio.Button value={TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE}>
                    {t('data.dsd.timDimension.mode.values.range')}
                  </Radio.Button>
                  <Radio.Button value={TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS}>
                    {t('data.dsd.timDimension.mode.values.lastNPeriods')}
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          {timeDimensionMode === TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE
            ? (
              <Fragment>
                {fetchValuesForLayoutAnnotations
                  ? (
                    <Fragment>
                      <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                        <Col span={SPAN_FULL}>
                          <Form.Item
                            label={t('data.dsd.timDimension.defaultTimeStart.label')}
                            {...timeDimensionEditFormItemLayout}
                          >
                            <Selector
                              disabled={disabled}
                              selectTitle={t('data.dsd.timDimension.defaultTimeStart.selector.selectTitle')}
                              resetTitle={t('data.dsd.timDimension.defaultTimeStart.selector.resetTitle')}
                              onSelect={() => this.onTimeDimensionFromListShow()}
                              onReset={() => this.onTempTimeDimensionStartChange(null)}
                              value={tempTimeDimensionStart}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                        <Col span={SPAN_FULL}>
                          <Form.Item
                            label={t('data.dsd.timDimension.defaultTimeEnd.label')}
                            {...timeDimensionEditFormItemLayout}
                          >
                            <Selector
                              disabled={disabled}
                              selectTitle={t('data.dsd.timDimension.defaultTimeEnd.selector.selectTitle')}
                              resetTitle={t('data.dsd.timDimension.defaultTimeEnd.selector.resetTitle')}
                              onSelect={() => this.onTimeDimensionToListShow()}
                              onReset={() => this.onTempTimeDimensionEndChange(null)}
                              value={tempTimeDimensionEnd}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <EnhancedModal
                        visible={isTimeDimensionFromListVisible || isTimeDimensionToListVisible}
                        width={MODAL_WIDTH_MD}
                        title={t('components.treeFilter.timeDimension.valuesModal.title')}
                        footer={
                          <Button
                            onClick={() => {
                              this.onTimeDimensionFromListHide();
                              this.onTimeDimensionToListHide();
                            }}
                          >
                            {t('commons.buttons.close.title')}
                          </Button>
                        }
                        onCancel={() => {
                          this.onTimeDimensionFromListHide();
                          this.onTimeDimensionToListHide();
                        }}
                      >
                        <Call
                          cb={fetchValuesForLayoutAnnotations}
                          cbParam={timeDimensionId}
                          disabled={valuesForLayoutAnnotations}
                        >
                          <InfiniteScrollDataTable
                            isPaginated={false}
                            noFilter
                            noSort
                            data={valuesForLayoutAnnotations}
                            cols={
                              (valuesForLayoutAnnotations && valuesForLayoutAnnotations.length > 0)
                                ? [Object.keys(valuesForLayoutAnnotations[0])[0]]
                                : ["TIME_PERIOD"]
                            }
                            onRowClick={row => {
                              if (isTimeDimensionFromListVisible) {
                                this.onTempTimeDimensionStartChange(row[Object.keys(row)[0]]);
                                this.onTimeDimensionFromListHide();
                              } else {
                                this.onTempTimeDimensionEndChange(row[Object.keys(row)[0]]);
                                this.onTimeDimensionToListHide();
                              }
                            }}
                          />
                        </Call>
                      </EnhancedModal>
                    </Fragment>
                  )
                  : (
                    <Fragment>
                      <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                        <Col span={SPAN_FULL}>
                          <Form.Item
                            label={t('data.dsd.timDimension.defaultTimeStart.label')}
                            {...timeDimensionEditFormItemLayout}
                          >
                            <LocalizedMonthPicker
                              format="YYYY-MM"
                              value={tempTimeDimensionStart ? moment(tempTimeDimensionStart) : null}
                              disabled={disabled}
                              onChange={val => this.onTempTimeDimensionStartChange(val ? val.format("YYYY-MM") : null)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                        <Col span={SPAN_FULL}>
                          <Form.Item
                            label={t('data.dsd.timDimension.defaultTimeEnd.label')}
                            {...timeDimensionEditFormItemLayout}
                          >
                            <LocalizedMonthPicker
                              format="YYYY-MM"
                              value={tempTimeDimensionEnd ? moment(tempTimeDimensionEnd) : null}
                              disabled={disabled}
                              onChange={val => this.onTempTimeDimensionEndChange(val ? val.format("YYYY-MM") : null)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Fragment>
                  )}
                <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                  <Col span={SPAN_FULL}>
                    <Form.Item
                      label={t('data.dsd.timDimension.defaultLastNObservations.label')}
                      {...timeDimensionEditFormItemLayout}
                    >
                      <InputNumber
                        style={{width: "100%"}}
                        min={0}
                        precision={0}
                        value={tempTimeDimensionLastNObservations}
                        disabled={disabled}
                        onChange={val => this.onTempTimeDimensionLastNObservationsChange(val || null)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Fragment>
            )
            : (
              <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item
                    label={t('data.dsd.timDimension.defaultLastNPeriods.label')}
                    {...timeDimensionEditFormItemLayout}
                  >
                    <InputNumber
                      style={{width: "100%"}}
                      min={0}
                      precision={0}
                      value={tempTimeDimensionLastNPeriods}
                      disabled={disabled}
                      onChange={val => this.onTempTimeDimensionLastNPeriodsChange(val || null)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
        </EnhancedModal>
      </Fragment>
    );
  }
}

export default compose(
  translate(),
  connect(mapStateToProps)
)(Default);
